import { textResources } from '../../i18n/translations';

export const topicEventMap = {
    FAMILY: [
        {
            translation: textResources.needs.family.gift,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.family.educationCost,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.family.relocation,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.family.maritalStatusChange,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.general,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
    ],
    BUSINESS: [
        {
            translation: textResources.needs.business.buyCompany,
            defaultReminderDateOffset: {
                months: 6,
                days: 0,
            },
        },
        {
            translation: textResources.needs.business.sellCompany,
            defaultReminderDateOffset: {
                months: 12,
                days: 0,
            },
        },
        {
            translation: textResources.needs.business.succession,
            defaultReminderDateOffset: {
                months: 6,
                days: 0,
            },
        },
        {
            translation: textResources.needs.business.businessStartup,
            defaultReminderDateOffset: {
                months: 6,
                days: 0,
            },
        },
        {
            translation: textResources.needs.business.ownCompany,
            defaultReminderDateOffset: {
                months: 6,
                days: 0,
            },
        },
        {
            translation: textResources.needs.business.becomeSelfEmployed,
            defaultReminderDateOffset: {
                months: 6,
                days: 0,
            },
        },
        {
            translation: textResources.needs.general,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
    ],
    PASSION: [
        {
            translation: textResources.needs.passion.buyArtCollection,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.passion.sellArtCollection,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.passion.buyLuxuryGoods,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.passion.sellLuxuryGoods,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.passion.philanthropy,
            defaultReminderDateOffset: {
                months: 6,
                days: 0,
            },
        },
        {
            translation: textResources.needs.general,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
    ],
    REAL_ESTATE: [
        {
            translation: textResources.needs.realEstate.buyHome,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.realEstate.sellHome,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.realEstate.buyHolidayHome,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.realEstate.sellHolidayHome,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.realEstate.renovation,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.realEstate.investment,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.realEstate.sellInvestment,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.general,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
    ],
    WEALTH: [
        {
            translation: textResources.needs.wealth.addEvent,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
    ],
    SUCCESSION: [
        {
            translation: textResources.needs.succession.sellCompany,
            defaultReminderDateOffset: {
                months: 12,
                days: 0,
            },
        },
        {
            translation: textResources.needs.succession.succession,
            defaultReminderDateOffset: {
                months: 12,
                days: 0,
            },
        },
        {
            translation: textResources.needs.succession.givingToNextGeneration,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
        {
            translation: textResources.needs.succession.philanthropy,
            defaultReminderDateOffset: {
                months: 6,
                days: 0,
            },
        },
        {
            translation: textResources.needs.general,
            defaultReminderDateOffset: {
                months: 3,
                days: 0,
            },
        },
    ],
    RETIREMENT: [
        {
            translation: textResources.needs.retirement.ordinary,
            defaultReminderDateOffset: {
                months: 12,
                days: 0,
            },
        },
        {
            translation: textResources.needs.retirement.early,
            defaultReminderDateOffset: {
                months: 12,
                days: 0,
            },
        },
        {
            translation: textResources.needs.retirement.partial,
            defaultReminderDateOffset: {
                months: 12,
                days: 0,
            },
        },
        {
            translation: textResources.needs.general,
            defaultReminderDateOffset: {
                months: 12,
                days: 0,
            },
        },
    ],
};

export enum LifePlanModalStep {
    CLOSED = 'CLOSED',
    SELECT_TOPIC = 'STEP_SELECT_TOPIC',
    SELECT_EVENT = 'STEP_SELECT_EVENT',
    DEFINE_EVENT_DETAILS = 'STEP_DEFINE_EVENT_DETAILS',
}
